import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../services/client-services/auth.service';

@Injectable({ providedIn: 'root' })
export class RoutePermissionGuard implements CanActivate {

  constructor(
    private auth: AuthService,
    private toastr: ToastrService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    if (!this.auth.isLoggedIn()) {
      this.toastr.warning('Your session has expired. Please log in again.', 'SESSION EXPIRED');
      return this.router.parseUrl(this.router.url || '/login');
    }

    const moduleKey = route.data['moduleKey'];
    const action: 'View' | 'Edit' | 'Add' | 'Review' = route.data['action'] || 'View';

    if (!moduleKey) return true;

    const allowed = this.auth.hasAccess(moduleKey, action);

    if (!allowed) {
      this.toastr.info('The requested content is unavailable.', 'NOTICE');
      const currentUrl = this.router.url || '/';
      return this.router.parseUrl(currentUrl);
    }

    return true;
  }
}
